import { render, staticRenderFns } from "./escapeConfig.vue?vue&type=template&id=c15a406e&scoped=true"
import script from "./escapeConfig.vue?vue&type=script&lang=js"
export * from "./escapeConfig.vue?vue&type=script&lang=js"
import style0 from "./escapeConfig.vue?vue&type=style&index=0&id=c15a406e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15a406e",
  null
  
)

export default component.exports